import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Pagination, Table } from 'antd'
import { throttle } from '@utils/config'
import style from './index.less'

// eslint-disable-next-line react/forbid-foreign-prop-types
class ResizeTable extends PureComponent {
  state = { y: 0 }

  static propTypes = {
    dataSource: PropTypes.arrayOf(PropTypes.any),
    columns: PropTypes.arrayOf(PropTypes.any),
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    className: PropTypes.string,
    size: PropTypes.string,
    rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    pageSize: PropTypes.number,
    total: PropTypes.number,
    current: PropTypes.number,
    onChange: PropTypes.func,
    onRow: PropTypes.func,
    rowClassName: PropTypes.func
  }

  static defaultProps = {
    dataSource: [],
    loading: false,
    className: '',
    rowClassName: () => {},
    rowKey: 'key'
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize)
    setTimeout(() => this.setTableSize(), 1)
  }

  // 表格数据变化时，自动恢复到第一行数据
  componentWillUpdate() {
    this.scrollToFirstRow()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  setTableSize() {
    const tableHead = this.tableContent.querySelector('.ant-table-thead')
    const { clientHeight } = tableHead
    const tableHeight = this.tableContent.clientHeight
    const y = tableHeight - clientHeight - 64
    this.setState({ y })
  }

  scrollToFirstRow = () => {
    const tableBody = this.tableContent.querySelector('.ant-table-body')
    tableBody.scrollTop = 0
  }

  onRowClick = e => {
    console.log(e)
  }

  resize = () => {
    throttle(() => {
      this.setTableSize()
    }, 600)()
  }

  render() {
    const { props, state } = this
    const {
      dataSource,
      className,
      rowClassName,
      columns,
      current,
      onChange,
      pageSize,
      rowKey,
      loading,
      total,
      size,
      expandedRowRender,
      onExpand,
      rowSelection,
      locale,
      simple,
      showTotal,
      itemRender
    } = props

    const { y } = state

    const pagination = pageSize && pageSize < total ?
    {
      pageSize,
      total,
      current,
      onChange,
      simple,
      showTotal,
      itemRender
    } : false

    let tableParam = {
      dataSource,
      className,
      rowClassName,
      columns,
      rowKey,
      loading,
      size,
      pagination: false,
      simple: false
    }

    if (simple) {
      tableParam = {
        ...tableParam,
        simple
      }
    }

    if (rowClassName) {
      tableParam = {
        ...tableParam,
        rowClassName
      }
    }

    if (showTotal) {
      tableParam = {
        ...tableParam,
        showTotal
      }
    }

    if (pagination) {
      tableParam = {
        ...tableParam,
        pagination
      }
    }
    if (expandedRowRender) {
      tableParam = {
        ...tableParam,
        expandedRowRender
      }
    }
    if (rowSelection) {
      tableParam = {
        ...tableParam,
        rowSelection
      }
    }
    if (locale) {
      tableParam = {
        ...tableParam,
        locale
      }
    }
    if (onExpand) {
      tableParam = {
        ...tableParam,
        onExpand
      }
    }
    return (
      <div
        ref={r => {
          this.tableContent = r
        }}
        className={style.table}
      >
        <div className={style.table_content}>
          <Table {...tableParam} scroll={{ y, scrollToFirstRowOnChange: true }} />
        </div>
      </div>
    )
  }
}

export default ResizeTable